import clientes from './clientes.json';

// En desarrollo se conserva el cliente usado anteriormente: JUANJOSE.
const hostname = window.location.hostname.toLowerCase();
const config = ['localhost', '127.0.0.1', '[::1]'].includes(hostname)
  ? clientes['clientes.gestrescan.com']
  : clientes[hostname];

if (!config) {
  throw new Error(`Dominio sin configuración de cliente: ${hostname}`);
}

export const ENDPOINT = config.ENDPOINT;
export const CLIENTE = config.CLIENTE;

export const CONFIRM_CODE = "Confirmar";
export const DEFAULT_STORE = "1";
export const DEFAULTSUBSTORE = "1";//ok
export const DEFAULT_ROLE = "0";
export const NON_ERASABLE_STATUSTYPE_ID = "10";//OK
export const NON_ERASABLE_REASONTYPE_ID = "26";//OK
export const NON_ERASABLE_STORE_ID = "10";//OK
export const NON_ERASABLE_USERACCOUNT_ID = "4";//ok
export const NON_ERASABLE_CODELER_ID= "834";//ok
export const NON_ERASABLE_OPTTYPE_ID="21";//ok
export const NON_ERASABLE_TREATMENTTYPE_ID= "86";//ok
export const NON_ERASABLE_PROCESSTYPE_ID= "29";//ok
export const NON_ERASABLE_DANGERROUS_ID= "15";//ok
export const NON_ERASABLE_COLOR_ID= "137";//ok
export const NON_ERASABLE_COMMUNITY_ID= "20";//ok
export const NON_ERASABLE_COUNTRY_ID= "247";//ok
export const NON_ERASABLE_DESCRIPTION_ID= "2";//ok
export const NON_ERASABLE_DOCUMENTTYPES_ID= "5";//ok
export const NON_ERASABLE_LANGUAGE_ID= "2";//ok
export const NON_ERASABLE_POSTALCODE_ID= "14617";//ok
export const NON_ERASABLE_PROVINCE_ID= "53";//ok
export const NON_ERASABLE_ROADTYPES_ID= "74";//ok
export const NON_ERASABLE_TYPESDI_ID= "2";//ok
export const NON_ERASABLE_ROLER_ID= "5"; //ok
export const NON_ERASABLE_EMPLOYEE_ID= "0";//ok
export const NON_ERASABLE_DRIVER_ID= "0";//ok
export const DEFAULTSTORE = "1";//ok
export const DEFAULTSTORETYPESDI = "1";//ok
export const DEFAULTEMPLOYEE= "1";//ok 
export const DEFAULTLANGUAGE= "1";//ok
export const DEFAULTCOLOR= "2";//ok
export const DEFAULTCOLOREMPLOYEE= "50";//ok 
export const DEFAULTTYPESOFTAX= "5";//ok 
export const LIMIT_PAGE = "2000";//ok 
export const LIMIT_PAGE_SIZE_SLIDE= "2000";//ok 
export const LIMIT_PAGE_BIG = "4000";//ok 
export const DEFAULT_TYPESDI= "1";//ok 
export const NON_ERASABLE_COMPANYTYPE_ID= "18";//ok 
export const NON_ERASABLE_MUNICIPALITY_ID= "8133";//ok 
export const NON_ERASABLE_INCIDENTTYPE_ID= "11";//ok 
export const NON_ERASABLE_SLATYPE_ID= "10";//ok 
export const NON_ERASABLE_RESOLUTIONTYPE_ID= "7";//ok 
export const NON_ERASABLE_PRODUCT_ID= "40";//ok 
export const NON_ERASABLE_PRODUCTLQUID_ID= "8";//ok 
export const NON_ERASABLE_SHEETSTATUS_ID= "3";//ok 
export const NON_ERASABLE_PAYMEMTTYPE_ID="3";//ok 
export const NON_ERASABLE_TYPESOFTAXES_ID="12";//ok
export const NON_ERASABLE_TYPESOFUNITS_ID="8";//ok
export const NON_ERASABLE_TYPESOFPRICES_ID= "4";//ok 
export const NON_ERASABLE_DEPARTMENT_ID="3";//
export const NON_ERASABLE_SECTION_ID="3";//
export const NON_ERASABLE_SUBSECTION_ID="3";//
export const NON_ERASABLE_ARTICLE_ID="0";//
export const NON_ERASABLE_ARTICLESBUTTON_ID= "0";//ok
export const NON_ERASABLE_TYPESOFVEHICLES_ID="2831";//ok
export const NON_ERASABLE_TYPESOFSIZES_ID="1";//ok
export const NON_ERASABLE_SEMITRAILERTYPE_ID="1";//ok
export const NON_ERASABLE_CRANEMODEL_ID="3";//ok

export const MAX_PDF= 20;
export const MAX_ZIP= 100;
export const CANVAS_SIZE = 170;
export const CLIENT_CANVAS_WIDTH = 400;
export const CLIENT_CANVAS_HEIGHT = 180;
export const CLIENT_CANVAS_DOUBLE_HEIGHT = 250;
